export default __webpack_public_path__ + "static/media/algoIcon.bf9ab881.png";